/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import request from '../../utils/request';
import NoDataAvailable from '../common/NoDataAvailable';
import SnackbarAlert from '../common/SnackbarAlert';
import TableSearch from '../common/TableSearch';
import Checkbox from '@mui/material/Checkbox';
import loader from '../common/loader.gif';
import lock from '../common/lock.png';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme
} from '@mui/material';
import Footer from 'src/components/Footer';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';

import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import React from 'react';
import { MailRounded } from '@mui/icons-material';
import MailPreview from './MailPreview';
import { checkPermission, checkRFQEditPermission } from 'src/utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import TableSearchWithIcon from '../common/TableSearchWithIcon';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import PolicyCompare from '../policies/PolicyCompare';
import DraftMailPreview from './DraftMailPreview';

const EndorsementDraftShareList = () => {
  const userDetail = JSON.parse(localStorage.getItem('userDatas'));
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const policyId = searchParams.get('policyid');
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isLoading, setLoading] = useState(false);
  const [offset, setOffset] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [policyQCPermission, setPolicyQCPermission] = useState<boolean>(false);
  interface SearchState {
    text: string;
    triggerId: number;
  }
  const [search, setSearch] = useState<SearchState>({
    text: '',
    triggerId: Date.now(),
  });
  const [openComareScreen, setOpenCompareScreen] = useState(false);
  const [selectPolicyCompare, setSelectPolicyCompare] = useState(null);
  const [endorsementListData, setEndorsementListData] = useState<any[]>([]);
  // const [customerType, setCustomerType] = useState<string>(null);
  const [customerType, setCustomerType] = useState<string>('All');
  const [endorsementType, setEndorsementType] = useState<string>('QC');
  const [corporateCustomerSearchValue, setCorporateCustomerSearchValue] =
    useState('');
  const [retailCustomerSearchValue, setRetailCustomerSearchValue] =
    useState('');
  const [corporateCustomerData, setCorporateCustomerData] = useState(
    userDetail?.userData?.userType !== 'SuperAdmin' ? [] : []
  );
  const [retailCustomerData, setRetailCustomerData] = useState(
    userDetail?.userData?.userType !== 'SuperAdmin' ? [] : []
  );
  const [branchContactDatas, setBranchContactData] = useState([]);
  const [branchContactSearchValue, setBranchContactSearchValue] = useState('');
  const [branchContactValue, setBranchContactValue] = useState<any>(null);
  const [insuranceCompanyList, setInsuranceCompanyList] = useState(
    userDetail?.userData?.userType !== 'SuperAdmin' ? [] : []
  );
  const [insuranceCompanyBranchList, setInsuranceCompanyBranchList] = useState(
    userDetail?.userData?.userType !== 'SuperAdmin' ? [] : []
  );
  const [corporateCustomerValue, setCorporateCustomerValue] =
    useState<any>(null);
  const [retailCustomerValue, setRetailCustomerValue] = useState<any>(null);
  const [branchData, setBranchData] = useState([]);
  const [branchSearchValue, setBranchSearchValue] = useState('');
  const [branchValue, setBranchValue] = useState<any>(
    userDetail?.userData?.userType !== 'SuperAdmin'
      ? userDetail?.userData?.activeBranchData?.userBranch?.id
      : null
  );
  const [insuranceCompanySearchValue, setInsuranceCompanySearchValue] =
    useState('');
  const [
    insuranceCompanyBranchSearchValue,
    setInsuranceCompanyBranchSearchValue
  ] = useState('');
  const [insuranceCompanyValue, setInsuranceCompanyValue] = useState<any>(null);
  const [insuranceCompanyBranchValue, setInsuranceCompanyBranchValue] =
    useState<any>(null);
  const [isAddingNewEmail, setIsAddingNewEmail] = useState(false);
  const [customEmail, setCustomEmail] = useState(null);
  const [endorsementSharePermission, setEndorsementSharePermission] = useState(true);
  const [showPreview, setShowPreview] = useState({
    status: false,
    checkedItems: null,
    endorsementType: null,
    insuranceCompanyValue: null,
    insuranceCompanyBranchValue: null,
    branchContactValue: null,
    customEmail: null
  });

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const handleChangePage = (event, newPage) => {
    setOffset(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+parseInt(event.target.value));
    setOffset(0);
  };

  const changeSearch = (searchValue) => {
    setOffset(0);
    setSearch(searchValue);
  };


  const checkRolePermission = async () => {
    await checkPermission('InsurancePolicyEndorsement', 'Share').then((permission) => {
      setEndorsementSharePermission(permission);
    });
  };

  const checkQcRolePermission = async () => {
    await checkPermission('InsurancePolicy', 'QC').then((permission) => {
      setPolicyQCPermission(permission);
    });
  };

  useEffect(() => {
    checkRolePermission();
    checkQcRolePermission();
  }, [])

  useEffect(() => {
    fetchInsuranceCompanyList();
  }, [insuranceCompanySearchValue]);

  useEffect(() => {
    fetchInsuranceCompanyBranchList();
  }, [insuranceCompanyValue, insuranceCompanyBranchSearchValue]);
  const fetchInsuranceCompanyList = () => {
    request({
      url: 'insurencecompany/getInsurenceCompanyList',
      method: 'POST',
      data: {
        search: insuranceCompanySearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 25,
        deleteStatus: false,
        status: true
      }
    })
      .then((response: any) => {
        setInsuranceCompanyList(response.insurencecompanyData);
      })
      .catch(function (err) {
        // setFetchLoader(false);
        if (err?.response?.status === 403) {
          setInsuranceCompanyList([]);
        }
      });
  };

  const fetchInsuranceCompanyBranchList = () => {
    request({
      url: 'company-branch/getCompanyBranchList',
      method: 'POST',
      data: {
        search: insuranceCompanyBranchSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 25,
        deleteStatus: false,
        status: true,
        companyId: insuranceCompanyValue
      }
    })
      .then((response: any) => {
        setInsuranceCompanyBranchList(response.companyBranchData);
      })
      .catch(function (err) {
        if (err?.response?.status === 403) {
          setInsuranceCompanyBranchList([]);
        }
        // setFetchLoader(false);
      });
  };

  useEffect(() => {
    getEndorsementData();
    setLoading(true);
  }, [])

  useEffect(() => {
    if (
      insuranceCompanyValue &&
      insuranceCompanyBranchValue &&
      branchValue !== null
    ) {
      getEndorsementData();
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    rowsPerPage,
    offset,
    search,
    // branchContactValue,
    retailCustomerValue,
    corporateCustomerValue,
    insuranceCompanyValue,
    insuranceCompanyBranchValue,
    endorsementType,
    branchValue?.id,
    customerType
  ]);

  const toggleCompareScreen = (policy) => {
    if (!openComareScreen) {
      setOpenCompareScreen(true)
      setSelectPolicyCompare(policy);
    } else {
      setSelectPolicyCompare(null);
      getEndorsementData();
      setOpenCompareScreen(false)
    }


  };
  const getEndorsementData = async (filter = true) => {
    request({
      url: 'insurancePolicy/getPolicyList',
      method: 'post',
      data: {
        search: search?.text,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: offset,
        limit: rowsPerPage,
        policyId: parseInt(policyId),
        type: endorsementType,
        retailCustomerId: retailCustomerValue,
        corporateCustomerId: corporateCustomerValue,
        insuranceCompanyId: insuranceCompanyValue,
        insuranceCompanyBranchId: insuranceCompanyBranchValue,
        branchId: branchValue?.id,
        shareScreen: true,
        qcDraft: true,
        status: 'Waiting For QC',
        customerId: retailCustomerValue ? retailCustomerValue : corporateCustomerValue,
        customerType: customerType
      }
    }).then(
      (response) => {
        setEndorsementListData(response['rows']);
        setTotalCount(response['count']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const getCorporateCustomerData = async () => {
    request({
      url: 'user/getAllowedCorporateCustomerList',
      method: 'post',
      data: {
        search: corporateCustomerSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        status: true,
        offset: 0,
        limit: 25,
        // branchId: branchValue?.id,
        branchId:
          userDetail?.userData?.userType !== 'SuperAdmin'
            ? userDetail?.userData?.activeBranchData?.userBranch?.id
            : branchValue?.id
      }
    }).then(
      (response) => {
        setCorporateCustomerData(response['customerData']);
      },
      (error) => {
        console.log(error);
        if (error?.response?.status === 403) {
          setCorporateCustomerData([]);
        }
      }
    );
  };

  const getRetailCustomerData = async () => {
    request({
      url: 'user/getAllowedCustomerList',
      method: 'post',
      data: {
        search: retailCustomerSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        status: true,
        offset: 0,
        limit: 25,
        // branchId: branchValue?.id,
        branchId:
          userDetail?.userData?.userType !== 'SuperAdmin'
            ? userDetail?.userData?.activeBranchData?.userBranch?.id
            : branchValue?.id
      }
    }).then(
      (response) => {
        setRetailCustomerData(response['customerData']);
      },
      (error) => {
        console.log(error);
        if (error?.response?.status === 403) {
          setRetailCustomerData([]);
        }
      }
    );
  };

  useEffect(() => {
    if (insuranceCompanyBranchValue) {
      fetchCompanyContactList();
    }
  }, [insuranceCompanyBranchValue, branchContactSearchValue]);

  const fetchCompanyContactList = () => {
    request({
      url: 'icb-contacts/getIcbContactList',
      method: 'POST',
      data: {
        search: branchContactSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 10000,
        branchId: insuranceCompanyBranchValue
      }
    })
      .then((response: any) => {
        setBranchContactData(response?.contactData);
      })
      .catch(function (err) { });
  };

  useEffect(() => {
    // if (branchValue?.id) {
    getRetailCustomerData();
    // }
  }, [retailCustomerSearchValue, branchValue?.id, customerType]);

  useEffect(() => {
    // if (branchValue?.id) {
    getCorporateCustomerData();
    // }
  }, [corporateCustomerSearchValue, branchValue?.id, customerType]);

  useEffect(() => {
    if (userDetail?.userData?.userType === 'SuperAdmin') {
      getBranchData();
    }
  }, [branchSearchValue]);

  const getBranchData = () => {
    request({
      url: 'branch/getBranchList',
      method: 'POST',
      data: {
        search: branchSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 25,
        status: true
      }
    }).then(
      (response: any) => {
        setBranchData(response.branchData);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const normalizeEmailList = (emailString) =>
    emailString
      ?.split(',')
      .map(e => e.trim())
      .filter(Boolean)
      .join(',');

  const isValidEmailList = (emailString) => {
    if (!emailString) return false;

    const emails = emailString
      .split(',')
      .map(e => e.trim())
      .filter(Boolean);

    if (emails.length === 0) return false;

    const emailRegex =
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    return emails.every(email => emailRegex.test(email));
  };


  const shareEndorement = () => {
    if (checkedItems.length === 0) {
      setErrorMessage('Please select at least one Policy!');
      return;
    }

    if (!branchContactValue && !customEmail) {
      setErrorMessage(
        'To share, please provide the Insurer Branch Contact ID or a different Email ID.'
      );
      return;
    }

    if (customEmail && !isValidEmailList(customEmail)) {
      setErrorMessage(
        'Please enter a valid email address. Multiple emails can be comma separated.'
      );
      return;
    }
    const normalizedEmail = normalizeEmailList(customEmail);
    setShowPreview({
      status: true,
      checkedItems,
      endorsementType,
      insuranceCompanyValue,
      insuranceCompanyBranchValue,
      branchContactValue,
      customEmail: normalizedEmail
    });
  };

  const sendMultiMail = (ids) => {
    setLoading(true);
    request({
      url: '/insurancePolicy/policyQcEndorsementBulkSubmit',
      method: 'post',
      data: {
        policyIds: ids,
        type: 'QC',
        insuranceCompanyId: insuranceCompanyValue,
        insuranceCompanyBranchId: insuranceCompanyBranchValue,
        insuranceCompanyBranchContact: branchContactValue?.id,
        otherContact: showPreview?.customEmail ?? null,
        sendMail: true

      }
    }) // eslint-disable-next-line
      .then(
        (response) => {
          setLoading(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Email Sent Successfully'
          });
          getEndorsementData();
          setShowPreview((prev) => ({
            ...prev,
            status: false
          }));
        },
        (error) => {
          setLoading(false);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: 'Something went wrong'
          });
          console.log(error);
        }
      );
  };

  const handleMultiShare = (event) => {
    setErrorMessage(null);
    const checkValue = event.target.value;

    if (checkedItems.includes(checkValue)) {
      // Remove from array immutably
      const updated = checkedItems.filter((item) => item !== checkValue);
      setCheckedItems(updated);
    } else {
      // Add to array immutably
      const updated = [...checkedItems, checkValue];
      setCheckedItems(updated);
    }
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const handleEditPermissionCheck = async (createdById, onSuccess, rfq) => {
    const userDatas = JSON.parse(localStorage.getItem('userDatas'));
    const loggedInUserId = userDatas?.userData?.id;

    // if (loggedInUserId === createdById) {
    //   onSuccess();
    //   return;
    // }

    try {
      const response = await checkRFQEditPermission(
        'Policy',
        'edit',
        createdById,
        rfq
      );
      if (response?.data?.permission) {
        onSuccess();
      } else {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: 'Edit access denied'
        });
      }
    } catch (error) {
      console.error('Edit permission check failed:', error);
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Something went wrong while checking permissions'
      });
    }
  };


  return (
    <>
      {showPreview.status ? (
        <DraftMailPreview
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          sendMultiMail={sendMultiMail}
          endorsementType={endorsementType ? endorsementType : 'ShareEndorsement'}
        />
      ) : null}
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid
            item
            xs={12}
            className="ListContainer"
            style={{ minHeight: '81vh' }}
          >
            {endorsementSharePermission ? (<Card>
              <Grid container mt={1} mb={1} mr={1} ml={1.5}>
                <Grid item xs={7}>
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item>
                      <Typography variant="h3" component="h3" gutterBottom>
                        {'Policy QC Drafts'}
                      </Typography>
                    </Grid>{' '}
                  </Grid>
                </Grid>
                <Grid item xs={1}>
                  <Button
                    sx={{ mt: { xs: 2, md: 0 }, mr: { md: 2 } }}
                    variant="contained"
                    startIcon={<MailRounded fontSize="small" />}
                    onClick={shareEndorement}
                  >
                    Share
                  </Button>
                </Grid>

                <Grid item xs={4}>
                  <TableSearchWithIcon
                    changeSearch={changeSearch}
                    deafultSearchValue={search.text}
                  />
                </Grid>
                {errorMessage !== null ? (
                  <Grid
                    color={'red'}
                    item
                    xs={12}
                    alignContent="flex-end"
                    sm={6}
                  >
                    {/* Please select at least one Endorsement! */}
                    {errorMessage}
                  </Grid>
                ) : null}
              </Grid>
              <Divider />
              <CardContent>
                <div>
                  <Grid container spacing={2}>
                    {userDetail?.userData?.userType === 'SuperAdmin' ? (
                      <Grid item xs={3}>
                        <Autocomplete
                          size={'small'}
                          disableClearable={branchSearchValue ? false : true}
                          value={branchValue}
                          id="branchId"
                          getOptionLabel={(companyBranchData) =>
                            ` ${companyBranchData.branchName} `
                          }
                          options={branchData}
                          inputValue={branchSearchValue}
                          noOptionsText={'No Data Found'}
                          onChange={(event: any, newValue: any) => {
                            if (newValue) {
                              setBranchValue(newValue);
                              setBranchSearchValue(newValue.branchName);
                            } else {
                              setBranchValue(null);
                              setBranchSearchValue('');
                            }
                            setCorporateCustomerValue(null);
                            setRetailCustomerValue(null);
                            setCorporateCustomerSearchValue('');
                            setRetailCustomerSearchValue('');
                            setCheckedItems([])
                            // setEndorsementType(null);
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'input') {
                              setBranchSearchValue(newInputValue);
                              if (newInputValue === '') {
                                setBranchSearchValue('');
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              // value={branchValue}
                              {...params}

                              label={
                                <span>
                                  Amex Branch  <span style={{ color: 'red' }}>*</span>
                                </span>
                              }
                              name="branchId"
                            />
                          )}
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={3}>
                      <Autocomplete
                        size={'small'}
                        disableClearable={
                          insuranceCompanySearchValue ? false : true
                        }
                        id="insuranceCompanyId"
                        getOptionLabel={(companyData) =>
                          ` ${companyData.name} `
                        }
                        options={insuranceCompanyList}
                        inputValue={insuranceCompanySearchValue}
                        noOptionsText={'No Data Found'}
                        onChange={(event: any, newValue: any) => {
                          if (newValue) {
                            setInsuranceCompanyValue(newValue.id);
                            setInsuranceCompanySearchValue(newValue.name);
                          } else {
                            setInsuranceCompanyValue(null);
                            setInsuranceCompanySearchValue('');
                          }
                          setBranchContactData([]);
                          setBranchContactValue(null);
                          setBranchContactSearchValue('');
                          setInsuranceCompanyBranchValue(null);
                          setInsuranceCompanyBranchSearchValue('');
                          setCorporateCustomerValue(null);
                          setRetailCustomerValue(null);
                          setCorporateCustomerSearchValue('');
                          setRetailCustomerSearchValue('');
                          setCheckedItems([])
                          // setEndorsementType(null);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'input') {
                            setInsuranceCompanySearchValue(newInputValue);
                            if (newInputValue === '') {
                              setInsuranceCompanySearchValue('');
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            // value={insuranceCompanyValue}
                            {...params}
                            label={
                              <span>
                                Insurer  <span style={{ color: 'red' }}>*</span>
                              </span>
                            }

                            name="insuranceCompanyId"
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <Autocomplete
                        size={'small'}
                        disableClearable={
                          insuranceCompanyBranchSearchValue ? false : true
                        }
                        id="insuranceCompanyBranchId"
                        getOptionLabel={(companyData) =>
                          ` ${companyData.branchName} `
                        }
                        disabled={insuranceCompanySearchValue ? false : true}
                        options={insuranceCompanyBranchList}
                        value={insuranceCompanyBranchValue}
                        inputValue={insuranceCompanyBranchSearchValue}
                        noOptionsText={'No Data Found'}
                        onChange={(event: any, newValue: any) => {
                          if (newValue) {
                            setInsuranceCompanyBranchValue(newValue.id);
                            setInsuranceCompanyBranchSearchValue(
                              newValue.branchName
                            );
                          } else {
                            setInsuranceCompanyBranchValue(null);
                            setInsuranceCompanyBranchSearchValue('');
                          }
                          setBranchContactData([]);
                          setBranchContactValue(null);
                          setBranchContactSearchValue('');
                          setCorporateCustomerValue(null);
                          setRetailCustomerValue(null);
                          setCorporateCustomerSearchValue('');
                          setRetailCustomerSearchValue('');
                          // setEndorsementType(null);
                          setCheckedItems([])
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'input') {
                            setInsuranceCompanyBranchSearchValue(newInputValue);
                            if (newInputValue === '') {
                              setInsuranceCompanyBranchSearchValue('');
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            // value={insuranceCompanyBranchValue}
                            {...params}
                            label={
                              <span>
                                Insurer Branch <span style={{ color: 'red' }}>*</span>
                              </span>
                            }
                            name="insuranceCompanyBranchId"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        select
                        name="customerType"
                        sx={{ width: '100%' }}
                        size="small"
                        InputLabelProps={{ shrink: customerType ? true : false }}
                        label="Customer Type"
                        value={customerType}
                        disabled={
                          branchValue === null ||
                          insuranceCompanyValue === null ||
                          insuranceCompanyBranchValue === null
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          setCustomerType(value);

                          // optional but recommended reset
                          if (value === 'corporate') {
                            setRetailCustomerValue(null);
                            setRetailCustomerSearchValue('');
                          }
                          if (value === 'retail') {
                            setCorporateCustomerValue(null);
                            setCorporateCustomerSearchValue('');
                          }
                         
                        }}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Corporate">Corporate Customer</MenuItem>
                        <MenuItem value="Retail">Retail Customer</MenuItem>
                      </TextField>
                    </Grid>


                    {customerType === 'Corporate' &&  <Grid item xs={3}>
                      <Autocomplete                        
                        size={'small'}
                        disableClearable={
                          corporateCustomerSearchValue ? false : true
                        }
                        id="customerId"
                        getOptionLabel={(corporateCustomerData) =>
                          ` ${corporateCustomerData?.companyName} `
                        }
                        options={corporateCustomerData}
                        value={corporateCustomerValue}
                        inputValue={corporateCustomerSearchValue}
                        noOptionsText={'No Data Found'}
                        onChange={(event: any, newValue: any) => {
                          if (newValue) {
                            setCorporateCustomerValue(newValue.id);
                            setCorporateCustomerSearchValue(
                              newValue.companyName
                            );
                          } else {
                            setCorporateCustomerValue(null);
                            setCorporateCustomerSearchValue('');
                          }
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'input') {
                            setCorporateCustomerSearchValue(newInputValue);
                            if (newInputValue === '') {
                              setCorporateCustomerSearchValue('');
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField

                            {...params}
                            label={'Corporate Customer'}
                            name="customerId"
                          />
                        )}
                      />
                    </Grid>}

                   {customerType === 'Retail' &&   <Grid item xs={3}>

                      <Autocomplete
                        size={'small'}
                        disableClearable={
                          retailCustomerSearchValue ? false : true
                        }
                        value={retailCustomerValue}                       
                        id="customerId"
                        getOptionLabel={(retailCustomerData) =>
                          ` ${retailCustomerData?.name} `
                        }
                        options={retailCustomerData}
                        inputValue={retailCustomerSearchValue}
                        noOptionsText={'No Data Found'}
                        onChange={(event: any, newValue: any) => {
                          if (newValue) {
                            setRetailCustomerValue(newValue.id);
                            setRetailCustomerSearchValue(newValue.name);
                          } else {
                            setRetailCustomerValue(null);
                            setRetailCustomerSearchValue('');
                          }

                        }}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'input') {
                            setRetailCustomerSearchValue(newInputValue);
                            if (newInputValue === '') {
                              setRetailCustomerSearchValue('');
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField

                            {...params}
                            label={'Retail Customer'}
                            name="customerId"
                          />
                        )}
                      />
                    </Grid>}



                    {!isAddingNewEmail ? (
                      <Grid item xs={3}>
                        <Autocomplete
                          size={'small'}
                          disableClearable={
                            insuranceCompanyBranchSearchValue ? false : true
                          }
                          id="insuranceCompanyBranchContactId"
                          getOptionLabel={(companyData) =>
                            ` ${companyData.firstName} ${companyData.lastName} (${companyData.email})`
                          }
                          disabled={
                            insuranceCompanyBranchValue && !isAddingNewEmail
                              ? false
                              : true
                          }
                          options={branchContactDatas}
                          value={branchContactValue}
                          inputValue={branchContactSearchValue}
                          noOptionsText={'No Data Found'}
                          onChange={(event: any, newValue: any) => {
                            if (newValue) {
                              setBranchContactValue(newValue);
                              setBranchContactSearchValue(newValue.firstName);
                            } else {
                              setBranchContactValue(null);
                              setBranchContactSearchValue('');
                            }
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'input') {
                              setBranchContactSearchValue(newInputValue);
                              if (newInputValue === '') {
                                setBranchContactValue('');
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              // value={branchContactValue}
                              {...params}
                              label={'Insurer Branch Contact'}
                              name="branchContactValue"
                            />
                          )}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={3}>
                        {isAddingNewEmail && (
                          <TextField
                            sx={{ width: '100%' }}
                            label="Enter New Email ID"
                            name="customEmail"
                            value={customEmail}
                            onChange={(e) => setCustomEmail(e.target.value)}
                            size="small"
                          />
                        )}
                      </Grid>
                    )}
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{ ml: 1 }}
                            checked={isAddingNewEmail}
                            onChange={(e) => {
                              setIsAddingNewEmail(e.target.checked);
                              if (e.target.checked) {
                                setBranchContactValue(null);
                                setBranchContactData([]);
                                setBranchContactSearchValue('');
                                setInsuranceCompanyBranchSearchValue('');
                              } else {
                                setCustomEmail(null);
                                fetchCompanyContactList();
                              }
                            }}
                          />
                        }
                        label="Send to a Different Email ID"
                      />
                    </Grid>
                  </Grid>
                </div>
              </CardContent>
              {isLoading ? (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          <img
                            alt="loader"
                            src={loader}
                            className="loader"
                            width={100}
                            height={100}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
              ) : (
                <>
                  <TableContainer>
                    {endorsementListData?.length > 0 ? (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Select</TableCell>
                            <TableCell style={{
                              maxWidth: 180,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}>Policy number</TableCell>
                            <TableCell sx={{ minWidth: '9vw' }}>
                              Policy Issue Date
                            </TableCell>
                            <TableCell>Placement ID</TableCell>
                            <TableCell>RFQ ID</TableCell>

                            <TableCell>Product Details</TableCell>
                            <TableCell>Customer</TableCell>
                            <TableCell>Insurance Company</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="left">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {endorsementListData?.map((item, index) => {
                            return (
                              <TableRow hover key={item?.id}>
                                <TableCell>
                                  {item.status?.toLowerCase() ===
                                    'shared to insurer' && (
                                      <Typography variant="caption" color="error">
                                        Shared
                                      </Typography>
                                    )}
                                  {item.status?.toLowerCase() !==
                                    'shared to insurer' && (
                                      <Checkbox
                                        key={item?.id}
                                        name="endorsementId"
                                        color="secondary"
                                        value={item?.id}
                                        onClick={handleMultiShare}
                                        checked={checkedItems.includes(item?.id.toString())}
                                        disabled={
                                          !(
                                            insuranceCompanyValue &&
                                            insuranceCompanyBranchValue &&
                                            branchValue !== null
                                          ) || item.status === 'Shared To Insurer'
                                        }
                                        style={{
                                          opacity:
                                            !(
                                              insuranceCompanyValue &&
                                              insuranceCompanyBranchValue &&
                                              branchValue !== null
                                            ) || item.status?.toLowerCase() === 'shared to insurer'
                                              ? 0.5
                                              : 1
                                        }}
                                      />
                                    )}
                                </TableCell>
                                {/* <TableCell>{index + 1}</TableCell> */}
                                <TableCell style={{ maxWidth: 150 }}>
                                  <Tooltip title={item?.policyNumber} arrow>
                                    <span
                                      style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 5,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        cursor: "pointer"
                                      }}
                                    >
                                      {item?.policyNumber}
                                    </span>
                                  </Tooltip>
                                </TableCell>
                                <TableCell sx={{ minWidth: '9vw' }}>
                                  {moment(item?.policyIssueDate).format(
                                    'DD-MM-YYYY'
                                  )}
                                </TableCell>
                                <TableCell>{`PLC#${item?.placementId}`}</TableCell>
                                <TableCell>{item?.rfq?.title}</TableCell>
                                {/* <TableCell>
                                                             {policy?.productMasterCategory?.categoryName}
                                                           </TableCell> */}
                                <TableCell>
                                  {item?.productCategory?.name} -{' '}
                                  {item?.placementSlip?.policyProduct?.name}
                                </TableCell>
                                <TableCell>
                                  {' '}
                                  {item?.customerType === 'Corporate' ? (
                                    <>
                                      {item?.corporateCustomer?.companyName
                                        ?.charAt?.(0)
                                        ?.toUpperCase() +
                                        item?.corporateCustomer?.companyName?.slice?.(
                                          1
                                        )}
                                      <br />
                                      {item?.corporateCustomer?.city}
                                      <br />
                                      {item?.corporateCustomer?.phone1}
                                    </>
                                  ) : (
                                    <>
                                      {item?.retailCustomer?.name
                                        ?.charAt?.(0)
                                        ?.toUpperCase() +
                                        item?.retailCustomer?.name?.slice?.(1)}
                                      <br />
                                      {item?.retailCustomer?.city}
                                      <br />
                                      {item?.retailCustomer?.phone}
                                    </>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {item?.insuranceCompany?.name}
                                </TableCell>
                                <TableCell align="center">
                                  {' '}
                                  <Chip
                                    label={
                                      item?.status === 'Inprogress'
                                        ? 'In Progress'
                                        : item?.status === 'CancelledAndReissued'
                                          ? 'Cancelled(Can Reissue)'
                                          : item?.status
                                    }
                                    color={
                                      item?.status === 'Live'
                                        ? 'success'
                                        : item?.status === 'Cancelled' ||
                                          item?.status === 'CancelledAndReissued' ||
                                          item?.status === 'Expired'
                                          ? 'error'
                                          : 'primary'
                                    }
                                  />
                                </TableCell>
                                <TableCell>
                                  {item.status === 'Waiting For QC' && (
                                    <Tooltip
                                      title={
                                        policyQCPermission ? (
                                          'QC'
                                        ) : (
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center'
                                            }}
                                          >
                                            {' '}
                                            <Avatar
                                              alt=""
                                              src={lock}
                                              sx={{
                                                width: 24,
                                                height: 24,
                                                marginRight: 1
                                              }}
                                            />
                                            You don't have permission to compare
                                            policy
                                          </div>
                                        )
                                      }
                                      arrow
                                    >
                                      <IconButton
                                        sx={{
                                          '&:hover': {
                                            background: theme.colors.primary.lighter
                                          },
                                          color: theme.palette.primary.main
                                        }}
                                        size="small"
                                        onClick={() => {
                                          handleEditPermissionCheck(
                                            item?.createdById,
                                            () => {
                                              if (policyQCPermission)
                                                toggleCompareScreen(item);
                                            },
                                            item?.rfq
                                          );
                                        }}
                                      >
                                        <CompareArrowsIcon fontSize="small"
                                          color={
                                            !policyQCPermission ||
                                              item?.policyCancellationStatus === true
                                              ? 'disabled'
                                              : 'primary'
                                          }
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </TableCell>

                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      <NoDataAvailable />
                    )}
                  </TableContainer>
                </>
              )}
              <Box p={2}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={offset}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </Card>) : (<NoPermissionContent />)}
          </Grid>
        </Grid>
        {openComareScreen && (
          //PolicyCompare replaced by PolicyDataCompare
          <PolicyCompare
            handleClose={toggleCompareScreen}
            PolicyCompare={selectPolicyCompare}
          />
        )}
      </Container>
      <Footer />
    </>
  );
};

export default EndorsementDraftShareList;
